import { render, staticRenderFns } from "./MyMessageList.vue?vue&type=template&id=3a780288"
import script from "./MyMessageList.vue?vue&type=script&lang=ts"
export * from "./MyMessageList.vue?vue&type=script&lang=ts"
import style0 from "../../scss/grid.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports